export default __webpack_public_path__ + "static/media/logo.733d6970.png";